import { EventDispatcher } from './EventDispatcher';
import gsap from 'gsap';

export default class ContentVideoController {
    constructor(selector, thresholdtype) {
        this.videos = selector;
        this.options = {
            threshold: thresholdtype === 'desktop' ? 0.5 : 0.7,
        };

        EventDispatcher.on('pageTransition', this.handlePageTransition.bind(this));
        this.observer = null;
    }

    handlePageTransition(e) {
        if (e.detail.namespace === 'enter' || e.detail.namespace === 'once') {
            const container = e.detail.container;

            if (!container) {
                return;
            }

            this.pauseAllVideos();

            const videos = container.querySelectorAll(this.videos);

            if (videos.length > 0) {
                this.initializeObserver(videos);
            }
        } else if (e.detail.namespace === 'leave') {
            if (this.observer) {
                this.disconnectObserver();
            }
        }
    }

    initializeObserver(videos) {
        if (this.observer) {
            this.disconnectObserver();
        }

        this.observer = new IntersectionObserver(this.handleIntersect.bind(this), this.options);

        videos.forEach((video) => {
            this.observer.observe(video);
        });
    }

    handleIntersect(entries) {
        entries.forEach((entry) => {
            const video = entry.target;

            if (entry.isIntersecting) {
                const source = video.querySelector('source');
                if (source && !video.getAttribute('src')) {
                    video.setAttribute('src', source.dataset.src);
                    video.load();

                    video.addEventListener(
                        'loadeddata',
                        () => {
                            video.style.opacity = '1';

                            gsap.to(video.parentNode.firstElementChild, { opacity: 0, duration: 0.25, ease: 'power2.out' });
                        },
                        { once: true }
                    );
                }
                if (video.paused) {
                    if (video._firstPlay && video.currentTime > 1) {
                        gsap.killTweensOf(video);
                        gsap.to(video, {
                            opacity: 0,
                            duration: 0.35,
                            ease: 'power2.out',
                            yoyo: true,
                            repeat: 1,
                            onRepeat: () => {
                                video.currentTime = 0;
                                video.play();
                            },
                        });
                    } else {
                        video._firstPlay = true;
                        video.play().catch((err) => {
                            if (err.name !== 'AbortError') {
                                console.error('Fehler beim Abspielen:', err);
                            }
                        });
                    }
                }
            } else {
                if (!video.paused) {
                    video.pause();
                }
            }
        });
    }

    pauseAllVideos() {
        const videos = document.querySelectorAll('video.content-video-loop');
        videos.forEach((video) => {
            if (!video.paused) {
                video.pause();
            }
        });
    }

    disconnectObserver() {
        if (this.observer) {
            this.observer.disconnect();
            this.observer = null;
        }
    }
}
